import { useNavigate } from "react-router-dom";
import { useAccount } from "../account/context";
import { useGlossary } from "../glossary/context";

export const Footer = () => {
  const navigate = useNavigate();
  const { warningContent } = useAccount();
  const { enabled, toggleEnabled } = useGlossary();

  return (
    <footer>
      <div>
        <div className="left">
          <h2>Kidney failure</h2>
          <p>Making a plan that works for you</p>
          <p>
            <a href="/documents/privacy-policy">Privacy Policy</a> |&nbsp;
            <a href="/documents/disclaimer">Disclaimer</a>
          </p>
          <p>
            <a href="/contact-us">Contact us</a>
          </p>
        </div>
        <ul>
          <li>
            <h2>Treatment Options</h2>
            <div>
              <ul>
                <li>
                  <a
                    href="/kidney-failure"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/kidney-failure");
                    }}
                  >
                    Kidney Failure
                  </a>
                </li>
                <li>
                  <a
                    href="/transplant"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/transplant");
                    }}
                  >
                    Transplant
                  </a>
                </li>
                <li>
                  <a
                    href="/kidney-failure"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/kidney-failure");
                    }}
                  >
                    Dialysis
                  </a>
                </li>
                <li>
                  <a
                    href="/fistulas"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/fistulas");
                    }}
                  >
                    Fistula
                  </a>
                </li>
                <li>
                  <a
                    href="/graft"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/graft");
                    }}
                  >
                    Graft
                  </a>
                </li>
                <li>
                  <a
                    href="/line"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/line");
                    }}
                  >
                    Line
                  </a>
                </li>
              </ul>
              <ul>
                <li>
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/compare");
                    }}
                    href="/compare"
                  >
                    Compare
                  </a>
                </li>
                <li>
                  <a
                    href="/reviews/"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/reviews/");
                    }}
                  >
                    Review
                  </a>
                </li>
              </ul>
            </div>
          </li>
          <li>
            <h2>Procedures</h2>
            <div>
              <ul>
                <li>
                  <a
                    href="/procedures/peritoneal-dialysis"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/procedures/peritoneal-dialysis");
                    }}
                  >
                    Peritoneal Dialysis
                  </a>
                </li>
                <li>
                  <a
                    href="/procedures/fistulas"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/procedures/fistulas");
                    }}
                  >
                    Arteriovenous Fistula
                  </a>
                </li>
                <li>
                  <a
                    href="/procedures/graft"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/procedures/graft");
                    }}
                  >
                    Arteriovenous Graft
                  </a>
                </li>
                <li>
                  <a
                    href="/line/procedures"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/line/procedures");
                    }}
                  >
                    Line
                  </a>
                </li>
              </ul>
            </div>
          </li>
          <li>
            <h2>Planning</h2>
            <div>
              <ul>
                <li>
                  <a
                    href="/planning/"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/planning/");
                    }}
                  >
                    Plan your journey
                  </a>
                </li>
              </ul>
            </div>
          </li>
          <li>
            <h2>Tools</h2>
            <div>
              <ul>
                <li>
                  <a
                    href="/forms/vascular-access-quality-of-life"
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/forms/vascular-access-quality-of-life");
                    }}
                  >
                    Quality of life survey
                  </a>
                </li>
                <li>
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/other-questionnaires");
                    }}
                    href="/other-questionnaires"
                  >
                    Other questionnaires
                  </a>
                </li>
                <li>
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      navigate("/tools/virtual-arm");
                    }}
                    href="/tools/virtual-arm"
                  >
                    Virtual arm
                  </a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>

      <div className="glossary-toggle">
        <span>Glossary tooltips:</span>
        <a
          href="#"
          className={enabled ? "active" : ""}
          onClick={(e) => { e.preventDefault(); if (!enabled) toggleEnabled(); }}
        >
          On
        </a>
        <a
          href="#"
          className={!enabled ? "active" : ""}
          onClick={(e) => { e.preventDefault(); if (enabled) toggleEnabled(); }}
        >
          Off
        </a>
      </div>

      <div className="warning-container">
        <div className="warning">
          <span dangerouslySetInnerHTML={{ __html: warningContent }}></span>
        </div>
      </div>
    </footer>
  );
};
